import { render, staticRenderFns } from "./form-v2.vue?vue&type=template&id=638c4fb6&scoped=true&"
import script from "./form-v2.vue?vue&type=script&lang=js&"
export * from "./form-v2.vue?vue&type=script&lang=js&"
import style0 from "./form-v2.vue?vue&type=style&index=0&id=638c4fb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638c4fb6",
  null
  
)

export default component.exports